import { Component, Inject, OnDestroy, OnInit, Optional, Self } from '@angular/core';
import { FormBuilder, NgControl } from '@angular/forms';
import { IAngularMyDpOptions } from '@nodro7/angular-mydatepicker';

import { Subscription } from 'rxjs';
import { APP_CONFIG } from '../../../app.config';
import { AssistantPopoverService } from '../../../common/assistant-popover.service';
import { DateUtilsService } from '../../../common/date-utils.service';
import { DATEPICKER_CONFIG } from '../../../common/datepicker-config';
import { FixDateService } from '../../../common/fixDate.service';
import { ValidationService } from '../../../common/validation.service';
import { ValueListsService } from '../../../common/value-lists.service';
import { AppConfig } from '../../../models/config/app-config';
import { FormSubGroupControl } from '../../../models/formControls/FormSubGroupControl';
import { ValueListItem } from '../../../models/rest/valuelist/valuelist';
import { VisumErfassungSubFormComponent } from '../visum-erfassung-sub-form/visum-erfassung-sub-form.component';

@Component({
  selector: 'app-reisedaten-kurzfristiger-aufenthalt',
  templateUrl: './reisedaten-kurzfristiger-aufenthalt.component.html',
  styleUrls: ['./reisedaten-kurzfristiger-aufenthalt.component.scss']
})
export class ReisedatenKurzfristigerAufenthaltComponent extends VisumErfassungSubFormComponent implements OnInit, OnDestroy {

  private subscriptions: Subscription = new Subscription();

  reisezweckListItems: ValueListItem[];
  anzahlEinreisenListItems: ValueListItem[];
  schengenlandListItems: ValueListItem[];

  constructor(fb: FormBuilder,
              private valueListsService: ValueListsService,
              private validationService: ValidationService,
              @Inject(DATEPICKER_CONFIG) public datepickerOptions: IAngularMyDpOptions,
              fixDateService: FixDateService,
              dateUtils: DateUtilsService,
              assistantPopoverService: AssistantPopoverService,
              @Inject(APP_CONFIG) public appConfig: AppConfig,
              @Optional() @Self() controlDir: NgControl) {
    super(controlDir, assistantPopoverService);

    this.form = this.wrapFormGroup(fb.group({
      reisezweck1: [null, validationService.getValidators('reisedaten.aufenthaltszweckListe', false, false, true)],
      reisezweck2: null,
      reisezweck3: null,
      weitereInformationen: [null, validationService.getValidators('reisedaten.weitereInformationen')],
      sonstigerReisezweck: [null, validationService.getValidators('reisedaten.angegebenerReisezweck')],
      ersteinreiseStaat: [null, validationService.getValidators('reisedaten.ersteinreiseStaat')],

      zielStaat1: [null, validationService.getValidators('reisedaten.hauptzielListe', false, false, true)],
      zielStaat2: null,
      zielStaat3: null,
      anzahlEinreisen: [null, validationService.getValidators('visumdaten.anzahlEinreisen')],

      ankunftsdatum: [null, validationService.getValidators('visumdaten.gueltigkeit.von', true)],
      abreisedatum: [null, validationService.getValidators('visumdaten.gueltigkeit.bisGenau.value', true)],

      einreisegenehmigung: new FormSubGroupControl()

    }));

    this.dateFixer = fixDateService.getConverter({ unknownReplacement: '00' });
    this.dateFormatter = dateUtils.getFormatter('yMd');
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.subscriptions.add(this.valueListsService.getValueListItems('aufenthaltszweck')
    .subscribe((listItems: ValueListItem[]) => {
      this.reisezweckListItems = listItems;
    }));

    this.subscriptions.add(this.valueListsService.getValueListItems('anzahleinreisen')
    .subscribe((listItems: ValueListItem[]) => {
      this.anzahlEinreisenListItems = listItems;
    }));

    this.subscriptions.add(this.valueListsService.getValueListItems('schengenland')
    .subscribe((listItems: ValueListItem[]) => {
      this.schengenlandListItems = listItems;
    }));

    this.subscriptions.add(this.form.controls.reisezweck1.valueChanges.subscribe(value => {
      if (value !== this.form.value.reisezweck1) {
        this.compress('reisezweck');
      }
    }));

    this.subscriptions.add(this.form.controls.reisezweck2.valueChanges.subscribe(value => {
      if (value !== this.form.value.reisezweck2) {
        this.compress('reisezweck');
      }
    }));

    this.subscriptions.add(this.form.controls.reisezweck3.valueChanges.subscribe(value => {
      if (value !== this.form.value.reisezweck3) {
        this.compress('reisezweck');
      }
    }));

    this.subscriptions.add(this.form.controls.zielStaat1.valueChanges.subscribe(value => {
      if (value !== this.form.value.zielStaat1) {
        this.compress('zielStaat');
      }
    }));

    this.subscriptions.add(this.form.controls.zielStaat2.valueChanges.subscribe(value => {
      if (value !== this.form.value.zielStaat2) {
        this.compress('zielStaat');
      }
    }));

    this.subscriptions.add(this.form.controls.zielStaat3.valueChanges.subscribe(value => {
      if (value !== this.form.value.zielStaat3) {
        this.compress('zielStaat');
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onValidatorUpdate() {
    super.onValidatorUpdate();
  }

}
